export enum EelPfc {
  NOEEI3037A = 'NOEEI_30_37_a',
  NOEEI3037F = 'NOEEI_30_37_f',
  NOEEI3037H = 'NOEEI_30_37_h',
  NOEEI3036 = 'NOEEI_30_36',
  AESITN = 'AES_ITN',
}

export const EelPfcOptionsMap = {
  [EelPfc.NOEEI3037A]: EelPfc.NOEEI3037A,
  [EelPfc.NOEEI3037F]: EelPfc.NOEEI3037F,
  [EelPfc.NOEEI3037H]: EelPfc.NOEEI3037H,
  [EelPfc.NOEEI3036]: EelPfc.NOEEI3036,
  [EelPfc.AESITN]: EelPfc.AESITN,
};

export enum ContentsType {
  DOCUMENTS = 'DOCUMENTS',
  GIFT = 'GIFT',
  SAMPLE = 'SAMPLE',
  MERCHANDISE = 'MERCHANDISE',
  'RETURN_MERCHANDISE' = 'RETURN_MERCHANDISE',
  'HUMANITARIAN_DONATION' = 'HUMANITARIAN_DONATION',
  OTHER = 'OTHER',
}

export const ContentsTypeOptionsMap = {
  [ContentsType.DOCUMENTS]: ContentsType.DOCUMENTS,
  [ContentsType.GIFT]: ContentsType.GIFT,
  [ContentsType.SAMPLE]: ContentsType.SAMPLE,
  [ContentsType.MERCHANDISE]: ContentsType.MERCHANDISE,
  [ContentsType.RETURN_MERCHANDISE]: ContentsType.RETURN_MERCHANDISE,
  [ContentsType.HUMANITARIAN_DONATION]: ContentsType.HUMANITARIAN_DONATION,
  [ContentsType.OTHER]: ContentsType.OTHER,
};

export enum Incoterm {
  DDU = 'DDU',
  DDP = 'DDP',
  FCA = 'FCA',
}

export const IncotermOptionsMap = {
  [Incoterm.DDU]: Incoterm.DDU,
  [Incoterm.DDP]: Incoterm.DDP,
  [Incoterm.FCA]: Incoterm.FCA,
};

export enum NonDelivery {
  RETURN = 'RETURN',
  ABANDON = 'ABANDON',
}

export const NonDeliveryOptionsMap = {
  [NonDelivery.RETURN]: NonDelivery.RETURN,
  [NonDelivery.ABANDON]: NonDelivery.ABANDON,
};

export enum B13AFilingOption {
  NONE_SELECTED = 'None',
  FILED_ELECTRONICALLY = 'FILED_ELECTRONICALLY',
  SUMMARY_REPORTING = 'SUMMARY_REPORTING',
  NOT_REQUIRED = 'NOT_REQUIRED',
}

export const B13AFilingOptionMap: Record<string, B13AFilingOption> = {
  [B13AFilingOption.NONE_SELECTED]: B13AFilingOption.NONE_SELECTED,
  [B13AFilingOption.FILED_ELECTRONICALLY]: B13AFilingOption.FILED_ELECTRONICALLY,
  [B13AFilingOption.NOT_REQUIRED]: B13AFilingOption.NOT_REQUIRED,
  [B13AFilingOption.SUMMARY_REPORTING]: B13AFilingOption.SUMMARY_REPORTING,
};

interface B13FilingOptionNumber {
  label: string;
  regex: RegExp;
  regexDisplay: string;
}
export const B13AFilingOptionNumberMap: Record<string, B13FilingOptionNumber> = {
  [B13AFilingOption.FILED_ELECTRONICALLY]: {
    label: 'B13A Proof of Report Number',
    regex: /^[A-Z]{2}[0-9]{13,23}$/,
    regexDisplay: 'AA####YYYYMMDDN, where N is 1 to 11 digits',
  },
  [B13AFilingOption.NOT_REQUIRED]: {
    label: 'B13A Exemption Number',
    regex: /^NDR[0-9]{1,2}$/,
    regexDisplay: 'NDR##',
  },
  [B13AFilingOption.SUMMARY_REPORTING]: {
    label: 'B13A Summary ID Number',
    regex: /^SUM[0-9]{4}$/,
    regexDisplay: 'SUM####',
  },
};

export enum TaxIDTypes {
  VAT = 'VAT',
  EIN = 'EIN',
  IOSS = 'IOSS',
}

export const TaxIDOptionsMap = {
  [TaxIDTypes.VAT]: TaxIDTypes.VAT,
  [TaxIDTypes.EIN]: TaxIDTypes.EIN,
  [TaxIDTypes.IOSS]: TaxIDTypes.IOSS,
};

export const TaxIDTypeVATMaxLength = 15;
export const TaxIDTypeEINMaxLength = 9;

export const ValidationMessagesMap = {
  b13aFilingOption: {
    invalid: 'Please choose a valid B13A Filing Option',
  },
  b13aNumber: {
    required: (label: string) => `Please enter a value for ${label || 'B13A Number'}`,
    invalid: (format: string) =>
      format ? `Expected format: ${format}` : 'Please enter a valid value',
  },
  contentsType: {
    required: 'Please choose type of content',
  },
  exporterReference: {
    tooLong: 'This field cannot be longer than 50 characters',
  },
  importerReference: {
    tooLong: 'This field cannot be longer than 50 characters',
  },
  license: {
    tooLong: 'This field cannot be longer than 15 characters',
  },
  certificate: {
    tooLong: 'This field cannot be longer than 12 characters',
  },
  certifySigner: {
    required: 'Please enter a value for signing person',
    tooLong: 'This field cannot be longer than 100 characters',
  },
  aesItn: {
    required: 'Please enter a value for AES / ITN',
    tooLong: 'This field cannot be longer than 15 characters',
    invalid: 'Expected format: X12345678901234',
  },
  notes: {
    tooLong: 'This field cannot be longer than 200 characters',
  },
  isCertify: {
    required: 'You must certify the validity of the information provided',
  },
  contentsExplanation: {
    required: 'Please enter a value for content explanation',
    tooLong: 'This field cannot be longer than 20 characters',
  },
  eoriNumber: {
    tooLong: 'This field cannot be longer than 19 characters',
    invalid: 'Expected format: PL1234567890ABCDEFG',
  },
  taxIdNumber: {
    tooLong: (maxLength: number) => {
      return `This field cannot be longer than ${maxLength} characters`;
    },
    invalid: (label: string) => {
      if (label === TaxIDTypes.VAT || label === TaxIDTypes.IOSS) {
        return 'Expected format: AA12345678AAA';
      } else {
        return 'Expected format: 123456789';
      }
    },
    required: (label: string) => `Please enter a value for ${label}`,
  },
};
